import { StyleSheet } from 'aphrodite';
import { defaultStyles } from 'library';

const styles = StyleSheet.create({
    tileSize: {
        position: 'relative',
        marginBottom: '56px',
    },
    wrapper: {
        '@media print': {
            padding: '20px 10px',
        },
    },
    h3: {
        marginTop: 0,
    },
    paragraph: {
        marginTop: '16px',
        marginBottom: '2rem',
        textAlign: 'center',
        '@media print, screen and (min-width: 990px)': {
            textAlign: 'left',
            marginLeft: '40px',
        },
        '@media print': {
            marginBottom: '0',
            marginLeft: '16px',
        },
    },
    buttonWrapper: {
        marginTop: '1rem',
        textAlign: 'center',
        '@media print': {
            display: 'none',
        },
    },
    errorTop: {
        display: 'inline-block',
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        margin: '1rem auto',
    },
    error: {
        display: 'inline-block',
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        marginTop: '1rem',
    }
});

export default styles;